import { FilledLinkToWebField } from '@prismicio/client';
import { ICtaButton } from './types';
import { CtaButtonSliceDefault } from '@monofront/slice-machine/prismicio-types';

export const mapCtaButton = ({
  prismicContent,
}: {
  prismicContent: CtaButtonSliceDefault;
}): ICtaButton => {
  const { primary } = prismicContent;
  const {
    internal_link: internalLink,
    external_link: externalLink,
    text,
  } = primary;

  return {
    ...primary,
    text: text as string,
    link: internalLink || (externalLink as FilledLinkToWebField)!.url,
  };
};
